import * as z from "zod/v4";

export const addConversationTrainingLabel = {
  name: "addConversationTrainingLabel" as const,
  input: z.object({
    trainingSetId: z.string(),
    conversationId: z.string(),
    messageId: z.string(),
    label: z.string(),
    notes: z.string(),
  }),
  output: z.null(),
};
